import { getI18n } from "react-i18next";
import { validateEmail, validatePhone, validateRequired } from "src/components/shared/Form/validation";
import { GarageKeyType } from "src/components/UserAccount/shared/GarageKey";
import { GarageRequestAccess } from "src/store/types/state";
import { ValidationResult } from "src/types/ValidationResult";

function validateRequestKeyByType(request: GarageRequestAccess): ValidationResult {
    const i18n = getI18n();
    if (request.garageKeyType === GarageKeyType.email) {
        const emailValidation = validateRequired(request.garageKey) && validateEmail(request.garageKey);
        if (!emailValidation) {
            return {
                errorMessage: i18n.t("UserAccount.AccessGarage.invalidEmail"),
                isValid: false,
            };
        }
    } else {
        const phoneValidation = validateRequired(request.garageKey) && validatePhone(request.garageKey);
        if (!phoneValidation) {
            return {
                errorMessage: i18n.t("UserAccount.AccessGarage.invalidPhone"),
                isValid: false,
            };
        }
    }

    return {
        errorMessage: "",
        isValid: true,
    };
}

export const validateRequestAccess = (request: GarageRequestAccess): ValidationResult => {
    const formatCheck = validateRequestKeyByType(request);
    if (!formatCheck.isValid) {
        return formatCheck;
    }

    return {
        errorMessage: "",
        isValid: true,
    };
};
